export default {
  data () {
    return {
      filters: {},
      filtersQuery: {},
      filtersInit: false
    }
  },
  computed: {
    privateFilterList () {
      return this.$_.reduce(this.filters, (list, filterModel) => {
        list.push(filterModel)
        return list
      }, [])
    },
    hasSomeFilterValue () {
      return !this.filtersInit
        ? false
        : this.privateFilterList.some((filterModel) => !filterModel.component.isClear)
    }
  },
  methods: {
    resetAllFiltersField () {
      this.privateFilterList.forEach((filterModel) => {
        filterModel.component.resetField()
      })
    },
    handleOnFilter () {
      if (this.hasSomeFilterValue) {
        this.resetAllFiltersField()
        this.requestGetDataDebounce()
      }
    },
    registryFilters () {
      return new Promise(resolve => {
        try {
          // reset
          this.filtersInit = false
          this.filtersQuery = {}
          // TODO: filters
          this.filters = Object.assign(
            {},
            this.model.columns.reduce((acc, col) => {
              if (col.filter) acc[col.filter.id] = this.parseFilter(col.filter)
              return acc
            }, {}),
            this.model.toolbar.filters.reduce((acc, filter) => {
              acc[filter.id] = this.parseFilter(filter)
              return acc
            }, {})
          )
          // TODO: NOTE#1 In next version NOW grid load on route change
          if (!Object.keys(this.filters).length) {
            this.$nextTick(() => {
              this.filtersInit = true
              this.$bus.$emit(`Filters-Grid-Init-${this.model.id}`, this.filtersInit)
            })
          }
          resolve('All filters registry')
        } catch (e) {
          throw new Error(e)
        }
      })
    },
    parseFilter (Config) {
      let filter = {
        id: Config.id,
        field: Config.field,
        type: Config.type,
        isMounted: false,
        component: null,
        config: Config
      }
      return filter
    },
    handleFilter (Handle) {
      this.filtersQuery[Handle.id] = Handle
      if (['error', 'mounted'].includes(Handle.type)) {
        this.handleFilterRegistry(Handle)
      } else if (['change'].includes(Handle.type) && this.filtersInit) {
        if (Handle.removeSkip) {
          this.hookFilterRemoveSkip()
        }
        this.requestGetDataDebounce()
      }
    },
    handleFilterRegistry (Handle) {
      this.filters[Handle.id].isMounted = true
      this.filters[Handle.id].component = Handle.component
      this.filters[Handle.id].place = Handle.component.place

      if (Handle.type !== 'error') {
        Handle.component.parseConfig()
      }

      let isAllFiltersMounted = this.privateFilterList.every(({ isMounted }) => isMounted)

      if (isAllFiltersMounted) {
        this.$nextTick(() => {
          this.filtersInit = true
          this.$bus.$emit(`Filters-Grid-Init-${this.model.id}`, this.filtersInit)
        })
      }
    }
  }
}
